import React from 'react';
import { Card, CardContent } from '../ui/card';
import { STAGE_BY_KEY } from '../DealStageSelect';

const fmtA = (n) => `A$${Math.round(n || 0).toLocaleString()}`;

/** Stage-by-stage pipeline funnel: deals, revenue and probability-weighted revenue / ARR. Click a bar to filter. */
export const DealStageFunnel = ({ groups = [], totals, onPick, active = [] }) => {
  const max = Math.max(1, ...groups.map((g) => g.revenue_aud || 0));
  return (
    <Card className="border-slate-200" data-testid="do-stage-funnel">
      <CardContent className="p-4">
        <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-2">
          <p className="text-[10px] uppercase tracking-wide text-slate-400 font-medium">Pipeline by deal stage</p>
          {totals && <p className="text-[11px] text-slate-600" data-testid="do-weighted-total">Weighted pipeline <b className="text-[#0F2040]">{fmtA(totals.weighted_revenue_aud)}</b> of {fmtA(totals.revenue_aud)} TCV · weighted ARR <b className="text-[#0F2040]">{fmtA(totals.weighted_arr_aud)}</b></p>}
        </div>
        {!groups.length && <p className="text-xs text-slate-400">No deals match.</p>}
        <div className="space-y-1.5">
          {groups.map((g) => {
            const meta = STAGE_BY_KEY[g.value];
            const on = active.includes(g.value);
            return (
              <button key={g.value} type="button" onClick={() => onPick?.('stage', g.value)} className={`w-full text-left rounded-md px-2 py-1.5 hover:bg-slate-50 ${on ? 'ring-1 ring-[#0F2040]/40 bg-slate-50' : ''}`} data-testid={`do-stage-row-${g.value}`}>
                <div className="flex items-center gap-2 text-[11px]">
                  <span className="w-40 shrink-0 font-medium text-slate-700 truncate">{g.label}</span>
                  <span className="flex-1 h-3 rounded bg-slate-100 overflow-hidden relative">
                    <span className={`absolute inset-y-0 left-0 rounded ${meta?.bar || 'bg-slate-300'} opacity-40`} style={{ width: `${Math.max(2, (g.revenue_aud / max) * 100)}%` }} />
                    <span className={`absolute inset-y-0 left-0 rounded ${meta?.bar || 'bg-slate-300'}`} style={{ width: `${Math.max(g.weighted_revenue_aud ? 2 : 0, (g.weighted_revenue_aud / max) * 100)}%` }} title="Weighted" />
                  </span>
                  <span className="w-14 text-right text-slate-500">{g.deals} deal{g.deals === 1 ? '' : 's'}</span>
                  <span className="w-28 text-right text-slate-700">{fmtA(g.revenue_aud)}</span>
                  <span className="w-28 text-right font-semibold text-[#0F2040]" title="Probability-weighted revenue">{fmtA(g.weighted_revenue_aud)}</span>
                </div>
              </button>
            );
          })}
        </div>
        <p className="mt-1 text-[10px] text-slate-400">Light bar = full-term revenue · solid = revenue × stage probability. Deals with no stage carry 0% weight.</p>
      </CardContent>
    </Card>
  );
};
